export default "__VITE_PUBLIC_ASSET__64ef3193__"